import request from "@/utils/request";
import Qs from "qs";
// 公共接口

// 获取前端报事报修工单的操作权限
export function getMaintenanceAuth(data) {
  return request({
    url: "/common/get_maintenance_auth",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取小程序人员的所有角色关系
export function miniUserRole(data) {
  return request({
    url: "/common/get_mini_user_role_rel",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取园区列表数据
export function openPark(data) {
  return request({
    url: "/common/get_park_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 获取企业列表数据
export function openCompany(data) {
  return request({
    url: "/common/get_company_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 获取角色列表数据
export function openRole(data) {
  return request({
    url: "/common/get_role_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 获取菜单列表数据
export function openMenu(data) {
  return request({
    url: "/common/get_menu_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 获取报事报修原因类型列表数据
export function maintenanceType(data) {
  return request({
    url: "/common/get_maintenance_type_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 获取后台用户列表数据
export function adminUser(data) {
  return request({
    url: "/common/get_admin_user_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 获取小程序用户列表数据
export function openAgoUser(data) {
  return request({
    url: "/common/get_user_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 通过工单原因类型获取对应的用户
export function getByUser(data) {
  return request({
    url: "/common/get_user_by_maintenance_type",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取转单原因列表数据
export function reasonLists(data) {
  return request({
    url: "/common/get_transfer_reason_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取巡检点位列表
export function positionLists(data) {
  return request({
    url: "/common/get_patrol_position_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取巡检路线列表
export function openPatrolPath(data) {
  return request({
    url: "/common/get_patrol_path_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 公共end

// 获取后台用户的权限
export function getRoleMenu(data) {
  return request({
    url: "/admin_user/get_menu_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 本地上传（多文件上传）
export function upImage(data) {
  return request({
    url: "/common/admin_local_upload",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除本地文件
// export function delImage(data) {
//   return request({
//     url: "/common/del_admin_local_image",
//     method: "post",
//     data: Qs.stringify(data),
//   });
// }
// 删除Oss图片文件（可多文件上传）
export function delImage(data) {
  return request({
    url: "/common/del_admin_oss_image",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 菜单列表
export function getMenuLists(data) {
  return request({
    url: "/menu/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 添加菜单
export function addMenu(data) {
  return request({
    url: "/menu/add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 菜单信息
export function menuInfo(data) {
  return request({
    url: "/menu/info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑菜单
export function editMenu(data) {
  return request({
    url: "/menu/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除菜单
export function delMenu(data) {
  return request({
    url: "/menu/del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 后台用户列表
export function userList(data) {
  return request({
    url: "/admin_user/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 后台用户添加
export function addUser(data) {
  return request({
    url: "/admin_user/add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 后台用户编辑
export function editUser(data) {
  return request({
    url: "/admin_user/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 后台用户删除
export function delUser(data) {
  return request({
    url: "/admin_user/del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取后台用户个人信息
export function userInfo(data) {
  return request({
    url: "/admin_user/info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 角色相关接口

// 角色列表
export function roleList(data) {
  return request({
    url: "/admin_role/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加角色
export function addRole(data) {
  return request({
    url: "/admin_role/add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除角色
export function delRole(data) {
  return request({
    url: "/admin_role/del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 编辑角色
export function editRole(data) {
  return request({
    url: "/admin_role/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 设置角色权限
export function setRole(data) {
  return request({
    url: "/admin_role/set_auth",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 角色信息
export function infoRole(data) {
  return request({
    url: "/admin_role/info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取角色的权限
export function getAuth(data) {
  return request({
    url: "/admin_role/get_auth",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 小程序角色

// 角色列表
export function miniRoleList(data) {
  return request({
    url: "/role/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加角色
export function miniAddRole(data) {
  return request({
    url: "/role/add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除角色
export function miniDelRole(data) {
  return request({
    url: "/role/del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 编辑角色
export function miniEditRole(data) {
  return request({
    url: "/role/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 设置app角色权限
export function miniSetRole(data) {
  return request({
    url: "/role/set_auth",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 设置小程序角色权限
export function xcxSetRole(data) {
  return request({
    url: "/role/set_mini_auth",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 角色信息
export function miniInfoRole(data) {
  return request({
    url: "/role/info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取角色的权限
export function miniGetAuth(data) {
  return request({
    url: "/role/get_auth",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 园区列表
export function parkList(data) {
  return request({
    url: "/park/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加园区
export function addpark(data) {
  return request({
    url: "/park/add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 编辑园区
export function editpark(data) {
  return request({
    url: "/park/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除园区
export function delpark(data) {
  return request({
    url: "/park/del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 园区信息
export function parkInfo(data) {
  return request({
    url: "/park/info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 园区前端用户列表
export function parkUser(data) {
  return request({
    url: "/park/user_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 园区前端用户添加
export function addParkUser(data) {
  return request({
    url: "/park/user_add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 园区前端用户编辑
export function editParkUser(data) {
  return request({
    url: "/park/user_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 园区前端用户删除
export function delParkUser(data) {
  return request({
    url: "/park/user_del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 园区前端用户个人信息
export function parkUserInfo(data) {
  return request({
    url: "/park/user_info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 下载园区用户模板
export function templatePark_user(data) {
  return request({
    url: "/park/user_import_template",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 企业员工申请列表
export function user_apply_list(data) {
  return request({
    url: "/company/user_apply_list",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 企业员工申请审核
export function user_apply_examine(data) {
  return request({
    url: "/company/user_apply_examine",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 企业员工申请批量审核
export function user_apply_batch_examine(data) {
  return request({
    url: "/company/batch_examine",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 导出企业列表模板
export function company_template(data) {
  return request({
    url: "/company/company_template",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 企业列表
export function companyList(data) {
  return request({
    url: "/company/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加企业
export function addCompany(data) {
  return request({
    url: "/company/add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 编辑企业
export function editCompany(data) {
  return request({
    url: "/company/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除企业
export function delCompany(data) {
  return request({
    url: "/company/del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 企业信息
export function infoCompany(data) {
  return request({
    url: "/company/info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 企业画像-员工增长趋势
export function companyUserTrend(data) {
  return request({
    url: "/company/company_user_trend",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 企业画像-访客趋势
export function visitorTrend(data) {
  return request({
    url: "/company/visitor_trend",
    method: "post",
    data: Qs.stringify(data),
  });
}





// 员工列表-企业员工列表
export function company_userLists(data) {
  return request({
    url: "/company_user/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 员工列表-添加企业用户
export function addCompany_user(data) {
  return request({
    url: "/company_user/add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 员工列表-编辑企业用户
export function editCompany_user(data) {
  return request({
    url: "/company_user/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 员工列表-删除企业用户
export function delCompany_user(data) {
  return request({
    url: "/company_user/del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 员工列表-企业用户信息
export function infoCompany_user(data) {
  return request({
    url: "/company_user/info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 导入企业用户信息
export function importCompany_user(data) {
  return request({
    url: "/company_user/import_user",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 下载企业用户模板
export function templateCompany_user(data) {
  return request({
    url: "/company_user/import_user_template",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 企业员工列表
export function companyUser(data) {
  return request({
    url: "/company/user_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加企业用户
export function addCompanyUser(data) {
  return request({
    url: "/company/user_add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 编辑企业用户
export function editCompanyUser(data) {
  return request({
    url: "/company/user_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除企业用户
export function delCompanyUser(data) {
  return request({
    url: "/company/user_del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取企业用户信息
export function companyUserInfo(data) {
  return request({
    url: "/company/user_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 前端用户
// 前端用户列表
export function agoList(data) {
  return request({
    url: "/user/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 前端用户添加   -废弃
export function addAgo(data) {
  return request({
    url: "/user/add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 前端用户编辑-废弃
export function editAgo(data) {
  return request({
    url: "/user/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 前端用户删除-废弃
export function delAgo(data) {
  return request({
    url: "/user/del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 前端用户个人信息-废弃
export function infoAgo(data) {
  return request({
    url: "/user/info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 前端用户的权限
export function roleAgo(data) {
  return request({
    url: "/user/get_menu_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 小程序菜单列表
export function miniMenu(data) {
  return request({
    url: "/mini_menu/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 小程序添加菜单
export function addMiniMenu(data) {
  return request({
    url: "/mini_menu/add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 小程序编辑菜单
export function editMiniMenu(data) {
  return request({
    url: "/mini_menu/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 小程序删除菜单
export function delMiniMenu(data) {
  return request({
    url: "/mini_menu/del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 小程序菜单信息
export function infoMiniMenu(data) {
  return request({
    url: "/mini_menu/info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// APP菜单列表
export function appMenu(data) {
  return request({
    url: "/app_menu/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// APP添加菜单
export function addAppMenu(data) {
  return request({
    url: "/app_menu/add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// APP编辑菜单
export function editAppMenu(data) {
  return request({
    url: "/app_menu/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// APP删除菜单
export function delAppMenu(data) {
  return request({
    url: "/app_menu/del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// APP菜单信息
export function infoAppMenu(data) {
  return request({
    url: "/app_menu/info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 报事报修类型列表
export function typeList(data) {
  return request({
    url: "/maintenance/type_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加报事报修类型
export function addType(data) {
  return request({
    url: "/maintenance/type_add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 编辑报事报修类型
export function eidtType(data) {
  return request({
    url: "/maintenance/type_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除报事报修类型
export function delType(data) {
  return request({
    url: "/maintenance/type_del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 报事报修类型信息
export function infoType(data) {
  return request({
    url: "/maintenance/type_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 设置园区的工单原因类型
export function setType(data) {
  return request({
    url: "/maintenance/set_park_maintenance_type",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 设置app工单原因的角色
export function setTypeRole(data) {
  return request({
    url: "/maintenance/set_type_role",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 设置小程序工单原因的角色
export function set_mini_type_role(data) {
  return request({
    url: "/maintenance/set_mini_type_role",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取小程序工单原因的角色
export function get_mini_type_role(data) {
  return request({
    url: "/maintenance/get_mini_type_role",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取app工单原因的角色
export function getTypeRole(data) {
  return request({
    url: "/maintenance/get_type_role",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 转单原因列表
export function reasonList(data) {
  return request({
    url: "/maintenance/transfer_reason_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加转单原因
export function addReason(data) {
  return request({
    url: "/maintenance/transfer_reason_add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 编辑转单原因
export function eidtReason(data) {
  return request({
    url: "/maintenance/transfer_reason_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除转单原因
export function delReason(data) {
  return request({
    url: "/maintenance/transfer_reason_del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 转单原因信息
export function infoReason(data) {
  return request({
    url: "/maintenance/transfer_reason_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 新增工单-自查报修
export function addSelf(data) {
  return request({
    url: "/maintenance/add_self",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 新增工单-业主报事
export function addProprietor(data) {
  return request({
    url: "/maintenance/add_proprietor",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 新增工单-住宅报修
export function addDwelling(data) {
  return request({
    url: "/maintenance/add_dwelling",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 报事报修工单列表
export function applyLists(data) {
  return request({
    url: "/maintenance/apply_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 报事报修-转单
export function transfer(data) {
  return request({
    url: "/maintenance/transfer",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 报事报修-派单
export function dispatch(data) {
  return request({
    url: "/maintenance/dispatch",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 报事报修-跟踪信息
export function maintenanceLogLists(data) {
  return request({
    url: "/maintenance/maintenance_log_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 报事报修-关闭工单
export function closeMaintenance(data) {
  return request({
    url: "/maintenance/close",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 报事报修-批注（评论）
export function commentMaintenance(data) {
  return request({
    url: "/maintenance/comment",
    method: "post",
    data: Qs.stringify(data),
  });
}



// 业主报事报修工单列表
export function proprietor_lists(data) {
  return request({
    url: "/maintenance/proprietor_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 业主报事报修工单列表导出
export function proprietor_lists_export(data) {
  return request({
    url: "/maintenance/proprietor_lists_export",
    method: "post",
    data: Qs.stringify(data),
    responseType: "blob",
  });
}




// 巡检

// 巡检点位列表
export function patrolList(data) {
  return request({
    url: "/patrol/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加巡检点位
export function addPatrol(data) {
  return request({
    url: "/patrol/add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 编辑巡检点位
export function editPatrol(data) {
  return request({
    url: "/patrol/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 巡检点位信息
export function infoPatrol(data) {
  return request({
    url: "/patrol/info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除巡检点位
export function delPatrol(data) {
  return request({
    url: "/patrol/del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 导入巡检点位
export function importPatrol(data) {
  return request({
    url: "/patrol/import",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 下载巡检点位导入模板
export function templatetPatrol(data) {
  return request({
    url: "/patrol/template",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 巡检路线列表
export function pathLists(data) {
  return request({
    url: "/patrol/path_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加巡检路线
export function addPath(data) {
  return request({
    url: "/patrol/path_add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加巡检路线
export function editPath(data) {
  return request({
    url: "/patrol/path_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 巡检路线信息
export function infoPath(data) {
  return request({
    url: "/patrol/path_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除巡检路线
export function delPath(data) {
  return request({
    url: "/patrol/path_del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 导入巡检点位
export function importPath(data) {
  return request({
    url: "/patrol/path_import_template",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 下载巡检点位导入模板
export function templatetPath(data) {
  return request({
    url: "/patrol/template",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 导入巡检路线
export function path_import_template(data) {
  return request({
    url: "/patrol/path_import_template",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 下载巡检路线模板
export function path_template(data) {
  return request({
    url: "/patrol/path_template",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 巡检任务列表
export function taskLists(data) {
  return request({
    url: "/patrol/task_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加巡检任务
export function addTask(data) {
  return request({
    url: "/patrol/task_add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 编辑巡检任务
export function editTask(data) {
  return request({
    url: "/patrol/task_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 巡检任务信息
export function infoTask(data) {
  return request({
    url: "/patrol/task_info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除巡检任务
export function delTask(data) {
  return request({
    url: "/patrol/task_del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 批量停用巡检任务
export function disableTask(data) {
  return request({
    url: "/patrol/task_disable",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 批量启用巡检任务
export function enableTask(data) {
  return request({
    url: "/patrol/task_enable",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 复制巡检任务
export function copyTask(data) {
  return request({
    url: "/patrol/task_copy",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 关闭每日巡检任务
export function closeTask(data) {
  return request({
    url: "/patrol/task_day_close",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 开启每日巡检任务
export function openDayTask(data) {
  return request({
    url: "/patrol/task_day_open",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 巡检记录列表
export function taskDayLists(data) {
  return request({
    url: "/patrol/task_day_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 巡检记录-任务详情
export function taskDayDetail(data) {
  return request({
    url: "/patrol/task_day_detail",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 巡检记录的任务进度
export function taskDayProgress(data) {
  return request({
    url: "/patrol/task_day_progress",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 新闻资讯
// 新闻列表
export function articleLists(data) {
  return request({
    url: "/article/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 新闻详情
export function articleDetail(data) {
  return request({
    url: "/article/info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加新闻资讯
export function addArticle(data) {
  return request({
    url: "/article/add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除新闻
export function delArticle(data) {
  return request({
    url: "/article/del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑新闻资讯
export function editArticle(data) {
  return request({
    url: "/article/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 公告管理
// 公告列表
export function tipsLists(data) {
  return request({
    url: "/tips/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 公告详情
export function tipsDetail(data) {
  return request({
    url: "/tips/info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加园区公告
export function addTips(data) {
  return request({
    url: "/tips/add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除公告
export function delTips(data) {
  return request({
    url: "/tips/del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑园区公告
export function editTips(data) {
  return request({
    url: "/tips/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 轮播管理
// 轮播图列表
export function bannerLists(data) {
  return request({
    url: "/banner/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 公告详情
export function bannerDetail(data) {
  return request({
    url: "/banner/info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加轮播图
export function addBanner(data) {
  return request({
    url: "/banner/add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除轮播图
export function delBanner(data) {
  return request({
    url: "/banner/del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑轮播图
export function editBanner(data) {
  return request({
    url: "/banner/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 访客预约
// 访客预约列表
export function callerLists(data) {
  return request({
    url: "/caller/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 访客预约审核
export function callerUpStatus(data) {
  return request({
    url: "/caller/up_status",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 访客码的通行列表
export function callerCarLists(data) {
  return request({
    url: "/caller/car_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 活动管理

// 活动报名列表导出
export function user_export(data) {
  return request({
    url: "/activity/user_export",
    method: "post",
    data: Qs.stringify(data),
    responseType: "blob",
  });
}

// 活动列表
export function activityLists(data) {
  return request({
    url: "/activity/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 活动报名列表
export function activityRegistered(data) {
  return request({
    url: "/activity/user_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 活动评论列表
export function activity_comment_lists(data) {
  return request({
    url: "/activity/comment_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除活动评论
export function activity_comment_del(data) {
  return request({
    url: "/activity/comment_del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 审核活动评论
export function activity_comment_audit(data) {
  return request({
    url: "/activity/comment_audit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 活动详情
export function activityDetail(data) {
  return request({
    url: "/activity/info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加活动
export function addActivity(data) {
  return request({
    url: "/activity/add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除活动
export function delActivity(data) {
  return request({
    url: "/activity/del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑活动
export function editActivity(data) {
  return request({
    url: "/activity/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 用户操作日志列表
export function logsList(data) {
  return request({
    url: "/logs/user_operate_logs_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取楼栋列表
export function get_space_lists(data) {
  return request({
    url: "/common/get_space_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取楼层列表
export function get_space_floor_lists(data) {
  return request({
    url: "/common/get_space_floor_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取房间列表
export function get_space_house_lists(data) {
  return request({
    url: "/common/get_space_house_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 住宅用户列表
export function houseUserList(data) {
  return request({
    url: "/user/house_user_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加住宅用户
export function houseUserAdd(data) {
  return request({
    url: "/user/house_user_add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 住宅用户编辑
export function houseUserEdit(data) {
  return request({
    url: "/user/house_user_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除住宅用户
export function houseUserDel(data) {
  return request({
    url: "/user/house_user_del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 住宅用户列表-住宅用户信息
export function houseUserInfo(data) {
  return request({
    url: "/user/house_user_info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 根据园区获得园区住宅房屋
export function get_park_houses(data) {
  return request({
    url: "/common/get_park_houses",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取企业所有房屋
export function get_company_house(data) {
  return request({
    url: "/common/get_company_house",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 能耗模板列表
export function get_energy_task_lists(data) {
  return request({
    url: "/common/get_energy_task_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}



// 获取装修巡检用户列表数据
export function get_renovation_user_lists(data) {
  return request({
    url: "/common/get_renovation_user_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}



// 根据住宅获取住宅所有住户
export function get_house_users(data) {
  return request({
    url: "/common/get_house_users",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 后台消息未读消息列表
export function messagesLists(data) {
  return request({
    url: "/admin_messages/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 消息详情+阅读消息
export function messagesInfo(data) {
  return request({
    url: "/admin_messages/info",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 品质巡检记录导出
export function task_day_lists_export(data) {
  return request({
    url: "/patrol/task_day_lists_export",
    method: "post",
    data: Qs.stringify(data),
    responseType: "blob",
  });
}


// 报事报修工单列表导出
export function maintenanceExport(data) {
  return request({
    url: "/maintenance/export",
    method: "post",
    data: Qs.stringify(data),
    responseType: "blob",
  });
}



// 访客预约列表导出
export function callerExport(data) {
  return request({
    url: "/caller/export",
    method: "post",
    data: Qs.stringify(data),
    responseType: "blob",
  });
}


// 创优-手动完成配置巡检任务
export function task_day_manual_work(data) {
  return request({
    url: "/patrol/task_day_manual_work",
    method: "post",
    data: Qs.stringify(data),
  });
}



// 访客预约取消
export function cancelCaller(data) {
  return request({
    url: "/caller/cancel",
    method: "post",
    data: Qs.stringify(data),
  });
}